/*eslint-disable*/
import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import { Info, AccountBox, House, Help, DriveEta, NewReleases } from "@material-ui/icons";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import { useSelector } from "react-redux";
import  languageJson  from "../../config/language";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  const auth = useSelector(state => state.auth);
  const socialinfos = useSelector(state => state.socialinfos);
  const [dataInfos, setInfos] = useState({});
  const [loggedIn, setLoggedIn] = useState(false);


  useEffect(()=>{
    if(socialinfos.infos){
      setInfos(socialinfos.infos);
    }
  },[socialinfos.infos]);

  useEffect(()=>{
    if(auth.info){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.info]);


  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="/"
          color="transparent"
          className={classes.navLink}
        >
          <House className={classes.icons} />{languageJson.home}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/features"
          color="transparent"
          className={classes.navLink}
        >
          <NewReleases className={classes.icons} />Novidades
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/booking-history"
          color="transparent"
          className={classes.navLink}
        >
          {loggedIn?
            <AccountBox className={classes.icons} /> 
            : 
            <AccountBox className={classes.icons} />  
          }         
         
          {loggedIn?
            languageJson.myaccount
            : 
           languageJson.login_signup
          }
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/faq"
          color="transparent"
          className={classes.navLink}
        >
          <Help className={classes.icons} />{languageJson.frequent_questions}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/driver-guide"
          color="transparent"
          className={classes.navLink}
        >
          <DriveEta className={classes.icons} />Guia do Motorista
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/about-us"
          color="transparent"
          className={classes.navLink}
        >
          <Info className={classes.icons} />{languageJson.about_us}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-twitter"
          title="Siga-nos no Instagram"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href={dataInfos.instagram_link}
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Siga-nos no Facebook"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href={dataInfos.fb_link}
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-facebook"} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}
